import React from 'react';
import { cn } from '@/lib/utils';

export const Table = ({ children, className }) => (
  <div className="overflow-x-auto -mx-6 px-6">
    <table className={cn('w-full text-left border-collapse', className)}>
      {children}
    </table>
  </div>
);

export const TableHeader = ({ children }) => (
  <thead className="border-b border-[var(--border)]">{children}</thead>
);

export const TableBody = ({ children }) => (
  <tbody className="divide-y divide-[var(--border)]">{children}</tbody>
);

export const TableRow = ({ children, onClick, className, ...rest }) => (
  <tr 
    onClick={onClick}
    className={cn(
      'transition-colors duration-150',
      onClick && 'cursor-pointer hover:bg-[var(--surface-hover)]',
      !onClick && 'hover:bg-[var(--surface-hover)]/50',
      className
    )}
    {...rest}
  >
    {children}
  </tr>
);

export const TableHead = ({ children, className }) => (
  <th className={cn(
    'py-3 px-4 text-[10px] uppercase tracking-[0.1em] font-semibold text-[var(--text-muted)]',
    className
  )}>
    {children}
  </th>
);

export const TableCell = ({ children, className }) => (
  <td className={cn(
    'py-3.5 px-4 text-sm text-[var(--text-primary)]',
    className
  )}>
    {children}
  </td>
);
